import {Action} from '@ngrx/store';
import {PageSettings} from '../../model/page-settings.model';
import {MaintenanceScope} from '../../model/maintenance-scope';

/**
 * All actions of the vehicle sub-store are described here
 * An action can have an optional payload
 */

export const UPDATE_VEHICLE = '[VEHICLE] UPDATE_VEHICLE';
export const UPDATED_VEHICLE = '[VEHICLE] UPDATED_VEHICLE';
export const UPDATE_VEHICLE_IN_LIST = '[VEHICLE] UPDATE_VEHICLE_IN_LIST';
export const UPDATED_VEHICLE_IN_LIST = '[VEHICLE] UPDATED_VEHICLE_IN_LIST';

export const RESET_VEHICLE = '[VEHICLE] RESET_VEHICLE';

export const UPDATE_MAINTENANCE_VEHICLES = '[VEHICLE] UPDATE_MAINTENANCE_VEHICLES';
export const UPDATED_MAINTENANCE_VEHICLES = '[VEHICLE] UPDATED_MAINTENANCE_VEHICLES';

export const UPDATE_VEHICLES_BASKET = '[VEHICLE] UPDATE_VEHICLES_BASKET';
export const UPDATED_VEHICLES_BASKET = '[VEHICLE] UPDATED_VEHICLES_BASKET';
export const DELETE_VEHICLE_FROM_BASKET = '[VEHICLE] DELETE_VEHICLE_FROM_BASKET';
export const RESET_VEHICLE_BASKET = '[VEHICLE] RESET_VEHICLE_BASKET';

export const UPDATE_VIEW_SETTINGS = '[VEHICLE] UPDATE_VIEW_SETTINGS';

export const UPDATE_VEHICLE_MAINTENANCE_SEARCH_CONFIG = '[VEHICLE_MAINTENANCE_SEARCH] UPDATE_VEHICLE_MAINTENANCE_SEARCH_CONFIG';
export const UPDATED_VEHICLE_MAINTENANCE_SEARCH_CONFIG = '[VEHICLE_MAINTENANCE_SEARCH] UPDATED_VEHICLE_MAINTENANCE_SEARCH_CONFIG';
export const UPDATED_VEHICLE_MAINTENANCE_SEARCH_ACTIVE_CATEGORY = '[VEHICLE_MAINTENANCE_SEARCH] UPDATED_VEHICLE_MAINTENANCE_SEARCH_ACTIVE_CATEGORY';
export const UPDATED_VEHICLE_MAINTENANCE_SEARCH_SELECTED_FILTERS = '[VEHICLE_MAINTENANCE_SEARCH] UPDATED_VEHICLE_MAINTENANCE_SEARCH_SELECTED_FILTERS';
export const UPDATED_VEHICLE_MAINTENANCE_SEARCH_PAGE_SETTINGS = '[VEHICLE_MAINTENANCE_SEARCH] UPDATED_VEHICLE_MAINTENANCE_SEARCH_PAGE_SETTINGS';

export const UPDATE_OPEN_TASKS = '[VEHICLE_MAINTENANCE_SEARCH] UPDATE_OPEN_TASKS';
export const UPDATED_OPEN_TASKS = '[VEHICLE_MAINTENANCE_SEARCH] UPDATED_OPEN_TASKS';

export const UPDATE_ENFORCED_AUCTION_BASE_VEHICLES = '[VEHICLE] UPDATE_ENFORCED_AUCTION_BASE_VEHICLES';
export const UPDATED_ENFORCED_AUCTION_BASE_VEHICLES = '[VEHICLE] UPDATED_ENFORCED_AUCTION_BASE_VEHICLES';

export const UPDATE_ENFORCED_AUCTION_VEHICLE = '[VEHICLE] UPDATE_ENFORCED_AUCTION_VEHICLE';
export const UPDATED_ENFORCED_AUCTION_VEHICLE = '[VEHICLE] UPDATED_ENFORCED_AUCTION_VEHICLE';

export const UPDATE_SCOPE = '[VEHICLE] UPDATE_SCOPE';

export const INIT_USER_SUBSTITUTIONS = '[VEHICLE_MAINTENANCE] INIT_USER_SUBSTITUTIONS';
export const UPDATE_USER_SUBSTITUTIONS = '[VEHICLE_MAINTENANCE] UPDATE_USER_SUBSTITUTIONS';
export const UPDATED_USER_SUBSTITUTIONS = '[VEHICLE_MAINTENANCE] UPDATED_USER_SUBSTITUTIONS';

export const UPDATE_PAGE_SETTINGS_PAGE_CHANNEL = '[VEHICLE_MAINTENANCE] UPDATE_PAGE_SETTINGS_PAGE_CHANNEL';

/**
 * UPDATE ACTIONS
 */
export class UpdateScopeAction implements Action {
  readonly type = UPDATE_SCOPE;

  constructor(public payload: MaintenanceScope) {
  }
}

export class UpdateVehicleAction implements Action {
  readonly type = UPDATE_VEHICLE;

  constructor(public id: number) {
  }
}

export class UpdateVehicleInListAction implements Action {
  readonly type = UPDATE_VEHICLE_IN_LIST;

  constructor(public id: number, public isEnforcedAuction: boolean) {
  }
}

export class ResetVehicleAction implements Action {
  readonly type = RESET_VEHICLE;
}

export class UpdateMaintenanceVehiclesAction implements Action {
  readonly type = UPDATE_MAINTENANCE_VEHICLES;

  constructor(public channel: DistributionChannel) {
  }
}

export class UpdateViewSettings implements Action {
  readonly type = UPDATE_VIEW_SETTINGS;

  constructor(public settings: ViewTag[]) {
  }
}

export class UpdateVehiclesBasketAction implements Action {
  readonly type = UPDATE_VEHICLES_BASKET;

  constructor(public vehicle: VehicleBaseDto) {
  }
}

export class DeleteVehicleFromBasketAction implements Action {
  readonly type = DELETE_VEHICLE_FROM_BASKET;

  constructor(public vehicle: VehicleBaseDto) {
  }
}

export class ResetVehicleBasketAction implements Action {
  readonly type = RESET_VEHICLE_BASKET;

}

export class UpdateEnforcedAuctionBaseVehicles implements Action {
  readonly type = UPDATE_ENFORCED_AUCTION_BASE_VEHICLES;
}

export class UpdateEnforcedAuctionBaseVehicleAction implements Action {
  readonly type = UPDATE_ENFORCED_AUCTION_VEHICLE;

  constructor(public payload: EnforcedAuctionVehicleBaseDto) {
  }
}

export class InitUserSubstitutionsAction implements Action {
  readonly type = INIT_USER_SUBSTITUTIONS;
}

export class UpdateUserSubstitutionsAction implements Action {
  readonly type = UPDATE_USER_SUBSTITUTIONS;

  constructor(public payload: number[]) {
  }
}

/**
 * UPDATED ACTIONS
 */

export class UpdatedVehicleAction implements Action {
  readonly type = UPDATED_VEHICLE;

  constructor(public payload: VehicleBaseDto) {
  }
}

export class UpdatedVehicleInListAction implements Action {
  readonly type = UPDATED_VEHICLE_IN_LIST;

  constructor(public payload: VehicleBaseDto) {
  }
}

export class UpdatedMaintenanceVehiclesAction implements Action {
  readonly type = UPDATED_MAINTENANCE_VEHICLES;

  constructor(public payload: VehicleBaseDto[]) {
  }
}

export class UpdatedVehiclesBasket implements Action {
  readonly type = UPDATED_VEHICLES_BASKET;

  constructor(public payload: VehicleBaseDto[]) {
  }
}

export class UpdateVehicleMaintenanceSearchConfigAction implements Action {
  readonly type = UPDATE_VEHICLE_MAINTENANCE_SEARCH_CONFIG;

  constructor(public channel: DistributionChannel) {
  }
}

export class UpdatedVehicleMaintenanceSearchConfigAction implements Action {
  readonly type = UPDATED_VEHICLE_MAINTENANCE_SEARCH_CONFIG;

  constructor(public filterConfig: SearchFilterConfig) {
  }
}

export class UpdatedVehicleMaintenanceSearchActiveCategoryAction implements Action {
  readonly type = UPDATED_VEHICLE_MAINTENANCE_SEARCH_ACTIVE_CATEGORY;

  constructor(public payload: Section, public channel: DistributionChannel) {
  }
}

export class UpdatedVehicleMaintenanceSearchSelectedFiltersAction implements Action {
  readonly type = UPDATED_VEHICLE_MAINTENANCE_SEARCH_SELECTED_FILTERS;

  constructor(public filters: SearchFilter[], public channel: DistributionChannel) {
  }
}

export class UpdatedVehicleMaintenanceSearchPageSettings implements Action {
  readonly type = UPDATED_VEHICLE_MAINTENANCE_SEARCH_PAGE_SETTINGS;

  constructor(public pageSettings: PageSettings) {
  }
}

export class UpdateOpenTasksAction implements Action {
  readonly type = UPDATE_OPEN_TASKS;

}

export class UpdatedOpenTasksAction implements Action {
  readonly type = UPDATED_OPEN_TASKS;

  constructor(public openTasks: OpenTaskListDto[]) {
  }
}

export class UpdatedEnforcedAuctionBaseVehicles implements Action {
  readonly type = UPDATED_ENFORCED_AUCTION_BASE_VEHICLES;

  constructor(public payload: EnforcedAuctionVehicleBaseDto[]) {
  }
}

export class UpdatedEnforcedAuctionBaseVehicleAction implements Action {
  readonly type = UPDATED_ENFORCED_AUCTION_VEHICLE;

  constructor(public payload: EnforcedAuctionVehicleBaseDto) {
  }
}

export class UpdatedUserSubstitutionsAction implements Action {
  readonly type = UPDATED_USER_SUBSTITUTIONS;

  constructor(public payload: UserSubstituteInformationDto[]) {
  }
}

export class UpdatePageSettingsPageChannel implements Action {
  readonly type = UPDATE_PAGE_SETTINGS_PAGE_CHANNEL;

  constructor(public page: number, public channel: DistributionChannel) {
  }
}

export type VehicleMaintenanceAction =
    UpdateVehicleAction
    | UpdatedVehicleAction
    | UpdateVehicleInListAction
    | UpdatedVehicleInListAction
    | ResetVehicleAction
    | UpdatedMaintenanceVehiclesAction
    | UpdateMaintenanceVehiclesAction
    | UpdateViewSettings
    | UpdateVehiclesBasketAction
    | UpdatedVehiclesBasket
    | DeleteVehicleFromBasketAction
    | ResetVehicleBasketAction
    | UpdateVehicleMaintenanceSearchConfigAction
    | UpdatedVehicleMaintenanceSearchConfigAction
    | UpdatedVehicleMaintenanceSearchActiveCategoryAction
    | UpdatedVehicleMaintenanceSearchSelectedFiltersAction
    | UpdatedVehicleMaintenanceSearchPageSettings
    | UpdateOpenTasksAction
    | UpdatedOpenTasksAction
    | UpdateEnforcedAuctionBaseVehicles
    | UpdatedEnforcedAuctionBaseVehicles
    | UpdateEnforcedAuctionBaseVehicleAction
    | UpdatedEnforcedAuctionBaseVehicleAction
    | UpdateScopeAction
    | UpdateUserSubstitutionsAction
    | UpdatedUserSubstitutionsAction
    | UpdatePageSettingsPageChannel;
